function bywaqaSubmitButtonPriceMarkup() {
  return `
    ADD TO CART —
    <span class="price price--final"></span>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.6001 12C3.6001 11.7613 3.69492 11.5324 3.8637 11.3636C4.03248 11.1948 4.2614 11.1 4.5001 11.1H17.2657L12.2761 6.34798C12.1869 6.26706 12.1148 6.16905 12.0642 6.05977C12.0135 5.95048 11.9853 5.83214 11.9813 5.71176C11.9772 5.59138 11.9974 5.47141 12.0405 5.35896C12.0837 5.2465 12.1489 5.14386 12.2325 5.05709C12.316 4.97033 12.4161 4.90123 12.5269 4.85386C12.6376 4.8065 12.7568 4.78186 12.8772 4.78138C12.9977 4.7809 13.117 4.80461 13.2281 4.85109C13.3392 4.89757 13.4399 4.96589 13.5241 5.05198L20.1241 11.352C20.2112 11.4359 20.2805 11.5366 20.3278 11.6479C20.3751 11.7593 20.3995 11.879 20.3995 12C20.3995 12.121 20.3751 12.2407 20.3278 12.352C20.2805 12.4634 20.2112 12.564 20.1241 12.648L13.5241 18.948C13.4399 19.0341 13.3392 19.1024 13.2281 19.1489C13.117 19.1954 12.9977 19.2191 12.8772 19.2186C12.7568 19.2181 12.6376 19.1935 12.5269 19.1461C12.4161 19.0987 12.316 19.0296 12.2325 18.9429C12.1489 18.8561 12.0837 18.7535 12.0405 18.641C11.9974 18.5286 11.9772 18.4086 11.9813 18.2882C11.9853 18.1678 12.0135 18.0495 12.0642 17.9402C12.1148 17.8309 12.1869 17.7329 12.2761 17.652L17.2657 12.9H4.5001C4.2614 12.9 4.03248 12.8052 3.8637 12.6364C3.69492 12.4676 3.6001 12.2387 3.6001 12Z" fill="#E0BFA8" />
    </svg>
  `;
}

function bywaqaEnsureSubmitButtonPriceMarkup(button) {
  if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return {};

  const textEl = button.querySelector('.add-to-cart-text');
  if (!textEl) return {};

  if (!textEl.querySelector('.price--final')) {
    textEl.innerHTML = bywaqaSubmitButtonPriceMarkup();
  }

  return {
    priceEl: textEl.querySelector('.price--final'),
  };
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        this.onVariantChange = this.onVariantChange.bind(this);
        this.addEventListener('variant:change', this.onVariantChange);

      }
      onVariantChange(event) {
        const variant = event.detail.variant;
        if (!variant) return;

        this.currentVariant = variant;
        this.updateSubmitButtonPrice();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const grinderAddon = this.querySelector('[data-grinder-addon]');
        const grinderAddonInput = grinderAddon?.querySelector('[data-grinder-addon-input]');
        const grinderAddonVariantId = grinderAddon?.dataset.grinderVariantId;
        const includeGrinderAddon = Boolean(grinderAddonInput?.checked && grinderAddonVariantId);

        config.body = formData;

        const addRequest = includeGrinderAddon
          ? this.addCoffeeAndGrinderAddon(formData, grinderAddonVariantId)
          : fetch(`${routes.cart_add_url}`, config).then((response) => response.json());

        addRequest
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      addCoffeeAndGrinderAddon(formData, grinderAddonVariantId) {
        return this.addCartItem(this.getCoffeeCartItem(formData))
          .then((response) => {
            if (response.status) return response;
            return this.addGrinderAddon(grinderAddonVariantId);
          })
          .then((response) => {
            if (response.status) return response;
            return this.getCartStateWithSections(grinderAddonVariantId);
          });
      }

      addCartItem(item) {
        const itemConfig = fetchConfig('javascript');
        itemConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete itemConfig.headers['Content-Type'];

        const itemFormData = new FormData();
        itemFormData.append('id', item.id);
        itemFormData.append('quantity', item.quantity || 1);
        if (item.selling_plan) itemFormData.append('selling_plan', item.selling_plan);
        if (item.properties) {
          Object.entries(item.properties).forEach(([key, value]) => {
            itemFormData.append(`properties[${key}]`, value);
          });
        }
        itemConfig.body = itemFormData;

        return fetch(`${routes.cart_add_url}`, itemConfig)
          .then((response) => {
            if (!response.ok) {
              return response.json().catch(() => ({
                status: response.status,
                description: window.cartStrings?.error || 'Cart error',
              }));
            }

            return {};
          });
      }

      getCoffeeCartItem(formData) {
        const coffeeItem = {
          id: Number(formData.get('id')),
          quantity: Number(formData.get('quantity') || 1),
        };
        const sellingPlan = formData.get('selling_plan') || this.getSelectedSellingPlanId();
        if (sellingPlan) coffeeItem.selling_plan = sellingPlan;

        formData.forEach((value, key) => {
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (!propertyMatch || value === '') return;
          coffeeItem.properties = coffeeItem.properties || {};
          coffeeItem.properties[propertyMatch[1]] = value;
        });

        return coffeeItem;
      }

      addGrinderAddon(grinderAddonVariantId) {
        return this.addCartItem({
          id: Number(grinderAddonVariantId),
          quantity: 1,
          properties: {
            _upsell_source: 'coffee_product_page_grinder_addon',
          },
        });
      }

      getCartStateWithSections(productId) {
        if (!this.cart) return fetch('/cart.js').then((response) => response.json());

        const sectionIds = this.cart.getSectionsToRender().map((section) => section.id).join(',');
        return Promise.all([
          fetch('/cart.js').then((response) => response.json()),
          fetch(`${routes.cart_url}?sections=${sectionIds}`).then((response) => response.json()),
        ]).then(([cart, sections]) => ({
          ...cart,
          id: Number(productId),
          sections,
        }));
      }

      getSellingPlanFields() {
        const productRoot = this.closest('product-info') || document;
        return [...productRoot.querySelectorAll('[name="selling_plan"]')].filter((field) => {
          if (field.disabled) return false;
          if (field.form === this.form) return true;
          if (field.getAttribute('form') === this.form.id) return true;
          return this.form.contains(field);
        });
      }

      getSelectedSellingPlanId() {
        const fields = this.getSellingPlanFields();
        const checkedField = fields.find((field) => field.checked && field.value);
        if (checkedField) return checkedField.value;

        const selectField = fields.find((field) => field.tagName === 'SELECT' && field.value);
        if (selectField) return selectField.value;

        const hiddenField = fields.find((field) => field.type === 'hidden' && field.value);
        if (hiddenField) return hiddenField.value;

        const populatedField = fields.find((field) => field.value);
        return populatedField?.value || '';
      }

      getQuantity() {
        const quantity = Number(this.form.querySelector('[name="quantity"]')?.value || 1);
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      }

      getGrinderAddon() {
        const addon = this.querySelector('[data-grinder-addon]');
        const input = addon?.querySelector('[data-grinder-addon-input]');
        return {
          checked: Boolean(input?.checked),
          price: Number(addon?.dataset.grinderAddonPrice || 1990),
        };
      }

      getVariantPlanAllocation(variant, sellingPlanId) {
        if (!sellingPlanId || !variant?.selling_plan_allocations) return null;
        return variant.selling_plan_allocations.find((allocation) => {
          return String(allocation.selling_plan_id) === String(sellingPlanId);
        });
      }

      updateSubmitButtonPrice(variant = this.currentVariant) {
        if (!variant || !this.submitButton) return;

        const { priceEl } = bywaqaEnsureSubmitButtonPriceMarkup(this.submitButton);
        if (!priceEl) return;

        this.currentVariant = variant;

        const sellingPlanId = this.getSelectedSellingPlanId();
        const allocation = this.getVariantPlanAllocation(variant, sellingPlanId);
        const quantity = this.getQuantity();
        const addon = this.getGrinderAddon();
        const unitPrice = Number(allocation?.price ?? variant.price ?? 0);
        const addonPrice = addon.checked ? addon.price : 0;
        const totalPrice = unitPrice * quantity + addonPrice;

        priceEl.innerHTML = formatMoney(totalPrice);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');

          this.submitButtonText.innerHTML = bywaqaSubmitButtonPriceMarkup();
          this.updateSubmitButtonPrice?.();
        }
      }


      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

const formatMoney = (cents) => {
  if (window.Shopify?.currency?.active) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: window.Shopify.currency.active,
    }).format(cents / 100);
  }
  return `$${(cents / 100).toFixed(2)}`;
};

document.querySelectorAll('product-form').forEach((productForm) => {
  const variantInput = productForm.querySelector('input[name="id"]');
  if (!variantInput) return;
  const productRoot = productForm.closest('product-info') || document;
  const form = productForm.querySelector('form');
  const submitButton = productForm.querySelector('.product-form__submit');
  const pricePerOunceAllocations = new WeakMap();
  let lastVariantId = variantInput.value;

  const getSelectedVariant = () => {
    const selectedVariantJson = productRoot.querySelector('variant-selects [data-selected-variant]')?.textContent;
    if (!selectedVariantJson) return null;

    try {
      return JSON.parse(selectedVariantJson);
    } catch (error) {
      return null;
    }
  };

  const getSelectedSellingPlanId = () => {
    if (!form) return '';

    const fields = [...productRoot.querySelectorAll('[name="selling_plan"]')].filter((field) => {
      if (field.disabled) return false;
      if (field.form === form) return true;
      if (field.getAttribute('form') === form.id) return true;
      return form.contains(field);
    });
    const checkedField = fields.find((field) => field.checked && field.value);
    if (checkedField) return checkedField.value;

    const selectField = fields.find((field) => field.tagName === 'SELECT' && field.value);
    if (selectField) return selectField.value;

    const hiddenField = fields.find((field) => field.type === 'hidden' && field.value);
    if (hiddenField) return hiddenField.value;

    const populatedField = fields.find((field) => field.value);
    return populatedField?.value || '';
  };

  const getPricePerOunceAllocations = (pricePerOunceElement) => {
    if (pricePerOunceAllocations.has(pricePerOunceElement)) {
      return pricePerOunceAllocations.get(pricePerOunceElement);
    }

    let allocations = [];
    try {
      const parsedAllocations = JSON.parse(pricePerOunceElement.dataset.sellingPlanAllocations || '[]');
      if (Array.isArray(parsedAllocations)) allocations = parsedAllocations;
    } catch (error) {
      allocations = [];
    }

    pricePerOunceAllocations.set(pricePerOunceElement, allocations);
    return allocations;
  };

  const getSelectedSellingPlanGroupId = (pricePerOunceElements) => {
    const sellingPlanId = getSelectedSellingPlanId();
    if (!sellingPlanId) return '';

    for (const pricePerOunceElement of pricePerOunceElements) {
      const selectedAllocation = getPricePerOunceAllocations(pricePerOunceElement).find((allocation) => {
        return String(allocation.selling_plan_id) === String(sellingPlanId);
      });

      if (selectedAllocation?.selling_plan_group_id) {
        return String(selectedAllocation.selling_plan_group_id);
      }
    }

    return '';
  };

  const formatPricePerOunce = (cents) => {
    if (window.Shopify?.currency?.active) {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify.currency.active,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    }

    return `$${(cents / 100).toFixed(2)}`;
  };

  const updateCoffeePricePerOunce = () => {
    const pricePerOunceElements = [...productRoot.querySelectorAll('[data-bywaqa-price-per-ounce]')];
    if (!pricePerOunceElements.length) return;

    const sellingPlanGroupId = getSelectedSellingPlanGroupId(pricePerOunceElements);

    pricePerOunceElements.forEach((pricePerOunceElement) => {
      const weightOunces = Number(pricePerOunceElement.dataset.weightOunces);
      const otpOnly = pricePerOunceElement.dataset.otpOnly === 'true';
      let priceInCents = Number(pricePerOunceElement.dataset.otpPrice);

      if (!otpOnly && sellingPlanGroupId) {
        const sellingPlanAllocation = getPricePerOunceAllocations(pricePerOunceElement).find((allocation) => {
          return String(allocation.selling_plan_group_id) === sellingPlanGroupId;
        });

        if (Number.isFinite(Number(sellingPlanAllocation?.price))) {
          priceInCents = Number(sellingPlanAllocation.price);
        }
      }

      if (!Number.isFinite(priceInCents) || priceInCents <= 0 || !Number.isFinite(weightOunces) || weightOunces <= 0) {
        return;
      }

      const pricePerOunceCents = Math.round(priceInCents / weightOunces);
      if (pricePerOunceCents <= 0) return;

      pricePerOunceElement.textContent = `(${formatPricePerOunce(pricePerOunceCents)}/oz)`;
    });
  };

  const getQuantity = () => {
    const quantity = Number(form?.querySelector('[name="quantity"]')?.value || 1);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  };

  const getGrinderAddon = () => {
    const addon = productForm.querySelector('[data-grinder-addon]');
    const input = addon?.querySelector('[data-grinder-addon-input]');
    return {
      checked: Boolean(input?.checked),
      price: Number(addon?.dataset.grinderAddonPrice || 1990),
    };
  };

  const getVariantPlanAllocation = (variant, sellingPlanId) => {
    if (!sellingPlanId || !variant?.selling_plan_allocations) return null;

    return variant.selling_plan_allocations.find((allocation) => {
      return String(allocation.selling_plan_id) === String(sellingPlanId);
    });
  };

  const updateSubmitButtonPrice = (variant = productForm.currentVariant) => {
    updateCoffeePricePerOunce();
    if (!variant || !submitButton) return;

    if (typeof productForm.updateSubmitButtonPrice === 'function') {
      productForm.updateSubmitButtonPrice(variant);
      return;
    }

    const { priceEl } = bywaqaEnsureSubmitButtonPriceMarkup(submitButton);
    if (!priceEl) return;

    productForm.currentVariant = variant;

    const sellingPlanId = getSelectedSellingPlanId();
    const allocation = getVariantPlanAllocation(variant, sellingPlanId);
    const quantity = getQuantity();
    const addon = getGrinderAddon();
    const unitPrice = Number(allocation?.price ?? variant.price ?? 0);
    const addonPrice = addon.checked ? addon.price : 0;

    priceEl.innerHTML = formatMoney(unitPrice * quantity + addonPrice);
  };

  const applyVariant = (variant) => {
    if (!variant) return;
    productForm.currentVariant = variant;
    updateSubmitButtonPrice(variant);
  };

  const schedulePriceUpdate = (variant = productForm.currentVariant) => {
    [0, 75, 250, 750].forEach((delay) => {
      setTimeout(() => updateSubmitButtonPrice(variant), delay);
    });
  };

  const updateButtonPrice = (variantId) => {
    const selectedVariant = getSelectedVariant();
    if (selectedVariant && String(selectedVariant.id) === String(variantId)) {
      applyVariant(selectedVariant);
      return;
    }

    fetch(`/variants/${variantId}.js`)
      .then((r) => r.json())
      .then(applyVariant);
  };

  updateButtonPrice(lastVariantId);

  variantInput.addEventListener('change', () => {
    if (variantInput.value !== lastVariantId) {
      lastVariantId = variantInput.value;
      updateButtonPrice(lastVariantId);
      return;
    }

    schedulePriceUpdate();
  });

  new MutationObserver(() => {
    if (variantInput.value !== lastVariantId) {
      lastVariantId = variantInput.value;
      updateButtonPrice(lastVariantId);
    } else {
      schedulePriceUpdate();
    }
  }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });

  if (submitButton) {
    new MutationObserver(() => {
      if (!submitButton.disabled && !submitButton.querySelector('.price--final')) {
        schedulePriceUpdate();
      }
    }).observe(submitButton, { childList: true, subtree: true });
  }

  productRoot.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (
      target.matches('[data-grinder-addon-input]') ||
      target.matches('[name="quantity"]') ||
      target.matches('[name="selling_plan"]')
    ) {
      schedulePriceUpdate();
    }
  });

  productRoot.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (
      target.closest('[data-grinder-addon]') ||
      target.closest('.loop-widget') ||
      target.closest('[class*="loop"]')
    ) {
      schedulePriceUpdate();
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data?.sectionId && productRoot.dataset.section && data.sectionId !== productRoot.dataset.section) return;
      if (!data?.variant) return;

      lastVariantId = String(data.variant.id);
      applyVariant(data.variant);
      schedulePriceUpdate(data.variant);
    });
  }
});


document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-cart-drawer-close]');
  if (!btn) return;

  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  drawer.close();
});

(() => {
  const updateCheckoutPrice = (cart) => {
    const btn = document.querySelector('#CartDrawer-Checkout');
    if (!btn || !cart) return;

    const priceEl = btn.querySelector('.cart-checkout-price');
    if (!priceEl) return;
    
    priceEl.textContent = `— ${formatMoney(cart.total_price)}`;      
   

  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
    updateCheckoutPrice(cartData);
  });

})();


(() => {
  const updateTotals = (cart) => {
    if (!cart) return;

    console.log('[CART TOTALS] update', cart);

    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    const savingsRow = document.querySelector('.totals__savings');
    const savingsEl = document.querySelector('[data-cart-savings]');
    const totalEl = document.querySelector('[data-cart-total]');

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(
        cart.original_total_price
      );
    }

    if (savingsEl && savingsRow) {
      if (cart.total_discount > 0) {
        savingsRow.removeAttribute('hidden');
        savingsEl.textContent = `−${formatMoney(
          cart.total_discount
        )}`;
      } else {
        savingsRow.setAttribute('hidden', '');
      }
    }

    if (totalEl) {
      totalEl.textContent = formatMoney(
        cart.total_price
      );
    }
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
    updateTotals(cartData);
  });
})();

(() => {
  const toggleUpsell = (cart) => {
    const upsell = document.querySelector('#CartUpsell');
    if (!upsell || !cart) return;

    let show = false;
    let grinderInCart = false;

    cart.items.forEach(item => {

      if (item.handle === upsell.dataset.grinderHandle) {
        grinderInCart = true;
      }

      const isSubscription = !!item.selling_plan_allocation;
      const grinderIncluded = item.variant_options?.includes('Grinder included'); // если прокидываешь через свойства

      if (!isSubscription && !grinderIncluded) {
        show = true;
      }
    });

    if (grinderInCart) show = false;

    upsell.style.display = show ? '' : 'none';
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
    toggleUpsell(cartData);
  });
})();

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-upsell-add]');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('loading');
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(() => {
    return fetch('/cart.js');
  })
  .then(r => r.json())
  .then((cart) => {
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'cart-upsell',
      cartData: cart
    });
  })
  .finally(() => {
    btn.classList.remove('loading');
    btn.disabled = false;
  });
});
